import { render, staticRenderFns } from "./AnswerImageUpload.vue?vue&type=template&id=9c0f35b6&scoped=true&"
import script from "./AnswerImageUpload.vue?vue&type=script&lang=ts&"
export * from "./AnswerImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerImageUpload.vue?vue&type=style&index=0&id=9c0f35b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0f35b6",
  null
  
)

export default component.exports